import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import PropTypes from "prop-types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

// for custom switch design

const IOSSwitch = Index.styled((props) => (
  <Index.Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 34,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 3,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#3c0000",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 14,
    height: 14,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const TableData = ({
  filteredData,
  currentPage,
  handleOpenAddSeasons,
  handleOpenDelete,
  handleChangeStatusSeason,
}) => {
  const location = PagesIndex.useLocation();
  const { state } = location;
  const { seriesId, title } = state;
  const { adminDetails } = PagesIndex.useSelector(
    (state) => state.AdminReducer
  );
  const navigate = PagesIndex.useNavigate();
  return filteredData?.length ? (
    filteredData
      ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
      ?.map((data, index) => {
        return (
          <Index.TableRow
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            key={data?._id}
          >
            <Index.TableCell
              component="td"
              variant="td"
              scope="row"
              className="table-td"
            >
              <Index.Typography className="admin-table-data-text">
                {" "}
                {(currentPage - 1) * 10 + (index + 1)}
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {" "}
                {data?.season}
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Typography className="admin-table-data-text">
                {" "}
                {title}
              </Index.Typography>
            </Index.TableCell>
            <Index.TableCell component="td" variant="td" className="table-td">
              {" "}
              {data?.cast
                ?.map((item) => item?.castId?.name)
                .toString()
                ?.replaceAll(",", ", ")}
            </Index.TableCell>
            <Index.TableCell component="td" variant="td" className="table-td">
              <Index.Tooltip
                title={data?.isActive ? "Active" : "Deactive"}
                arrow
                placement="bottom"
                className="admin-tooltip"
              >
                <Index.Box className="admin-switch-main">
                  <Index.FormControlLabel
                    control={<IOSSwitch sx={{ m: 1 }} />}
                    className="admin-switch-lable"
                    checked={data?.isActive}
                    onChange={() => handleChangeStatusSeason(data?._id)}
                  />
                </Index.Box>
              </Index.Tooltip>
            </Index.TableCell>
            {adminDetails?.roleId?.permissions?.includes("episode_view") && (
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title="Add Episode"
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Button
                    className="admin-table-data-btn"
                    onClick={() =>
                      navigate("/admin/episode", {
                        state: {
                          seriesId: seriesId,
                          seasonId: data?._id,
                          seriesTitle: title,
                          seasonTitle: data?.season,
                        },
                      })
                    }
                  >
                    <img
                      src={PagesIndex.Svg.darkplus}
                      className="admin-icon"
                      alt="Plus"
                    ></img>
                  </Index.Button>
                </Index.Tooltip>
              </Index.TableCell>
            )}
            {(adminDetails?.roleId?.permissions?.includes("season_delete") ||
              adminDetails?.roleId?.permissions?.includes("season_edit")) &&
              (
                <Index.TableCell component="td" variant="td" className="table-td">
                  <Index.Box className="admin-table-data-btn-flex">
                    {adminDetails?.roleId?.permissions?.includes("season_edit") && (
                      <Index.Tooltip
                        title="Edit"
                        arrow
                        placement="bottom"
                        className="admin-tooltip"
                      >
                        <Index.Button
                          className="admin-table-data-btn"
                          onClick={() => handleOpenAddSeasons("Edit", data)}
                        >
                          <img
                            src={PagesIndex.Svg.blueedit}
                            className="admin-icon"
                            alt="Edit"
                          ></img>
                        </Index.Button>
                      </Index.Tooltip>
                    )}

                    {adminDetails?.roleId?.permissions?.includes(
                      "season_delete"
                    ) && (
                        <Index.Tooltip
                          title="Delete"
                          arrow
                          placement="bottom"
                          className="admin-tooltip"
                        >
                          <Index.Button
                            className="admin-table-data-btn"
                            onClick={() => handleOpenDelete(data?._id)}
                          >
                            <img
                              src={PagesIndex.Svg.trash}
                              className="admin-icon"
                              alt="Delete"
                            ></img>
                          </Index.Button>
                        </Index.Tooltip>
                      )}
                  </Index.Box>
                </Index.TableCell>)}
          </Index.TableRow>
        );
      })
  ) : (
    <PagesIndex.DataNotFound />
  );
};

export default function Seasons() {
  const { adminDetails } = PagesIndex.useSelector(
    (state) => state.AdminReducer
  );
  const formRef = useRef();
  const location = PagesIndex.useLocation();
  const { state } = location;
  const { seriesId, title } = state;
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [id, setId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectData, setSelectData] = useState({});
  const [deleteButtonSpinner, setDeleteButtonSpinner] = useState(false);
  const [castData, setCastData] = useState([]);
  const [openAddSeasons, setOpenAddSeasons] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState("Add");
  const [searchValue, setSearchValue] = useState("");
  const [statusButtonSpinner, setStatusButtonSpinner] = useState(false);
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const initialValues = {
    season: id ? selectData?.season : "",
    cast: id
      ? selectData?.cast?.map((data) => {
        return { castId: data?.castId?._id };
      })
      : [],
  };
  useEffect(() => {
    handleGetActors();
    handleGetSeasons();
  }, []);
  useEffect(() => {
    let result = data.filter((data) => {
      let season = data?.season
        ?.toLowerCase()
        .includes(searchValue?.trim()?.toLowerCase());

      return season;
    });

    setCurrentPage(1);
    setFilteredData(result);
  }, [searchValue, data]);
  // add WebSeries modal
  const handleOpenAddSeasons = (op, data) => {
    setAddOrEdit(op);
    if (data) {
      setId(data?._id);
      setSelectData(data);
    }
    setOpenAddSeasons(true);
  };
  const handleCloseAddSeasons = () => {
    setId("");
    setOpenAddSeasons(false);
  };

  // delete modal
  const handleOpenDelete = (id) => {
    setId(id);
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setId("");
    setOpenDelete(false);
  };

  // page navigate

  const handleGetActors = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_ALL_ACTOR).then((res) => {
      if (res?.status === 200) {
        setCastData(res?.data?.filter((data) => data?.isActive));
      } else {
        PagesIndex.toasterError(res?.message);
      }
    });
  };
  const handleGetSeasons = () => {
    PagesIndex.apiGetHandler(`${PagesIndex.Api.GET_SEASON}/${seriesId}`).then(
      (res) => {
        setLoading(false);
        if (res?.status === 200) {
          setData(res?.data);
          setFilteredData(res?.data);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      }
    );
  };
  const handleAddEditSeason = (values) => {
    setButtonSpinner(true)
    const urlEncoded = new URLSearchParams();
    if (id) {
      urlEncoded.append("seasonId", id);
    }
    urlEncoded.append("webSeriesId", seriesId);
    urlEncoded.append("season", values?.season);
    urlEncoded.append("cast", JSON.stringify(values?.cast));
    PagesIndex.apiPostHandler(PagesIndex.Api.ADD_EDIT_SEASON, urlEncoded)
      .then((res) => {
        setButtonSpinner(false)
        if (res.status === 201 || res.status === 200) {
          handleCloseAddSeasons();
          handleGetSeasons();
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) => {
        PagesIndex.toasterError(err.response.message);
      });
  };
  const handleOpenStatusModal = (id) => {
    setId(id);
    setOpenStatusModal(true);
  };
  const handleCloseStatusModal = () => {
    setId("");
    setOpenStatusModal(false);
  };
  const handleStatus = () => {
    setStatusButtonSpinner(true)
    PagesIndex.apiGetHandler(`${PagesIndex.Api.SEASON_STATUS}/${id}`).then(
      (res) => {
        setStatusButtonSpinner(false)
        if (res.status === 200) {
          handleGetSeasons();
          handleCloseStatusModal();
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      }
    );
  };
  const handleDeleteWebSeason = () => {
    setDeleteButtonSpinner(true)
    PagesIndex.apiGetHandler(`${PagesIndex.Api.DELETE_SEASON}/${id}`).then(
      (res) => {
        setDeleteButtonSpinner(false)
        if (res.status === 200) {
          handleCloseDelete();
          handleGetSeasons();
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      }
    );
  };
  const ScrollIntoView = () => {
    // Scroll to the first error when errors change
    const { errors, isSubmitting } = PagesIndex.useFormikContext(); // Extracting errors from the Formik context
    useEffect(() => {
      if (errors && Object.keys(errors).length > 0) {
        const firstErrorField = Object.keys(errors)[0];
        let scrollDiv = document.getElementById("scrollDiv");
        const firstErrorElement = document.querySelector(
          `[id="${firstErrorField}"]`
        );
        if (firstErrorElement) {
          scrollDiv.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          firstErrorElement.focus();
        }
      }
    }, [isSubmitting]);
  };
  return (
    <>
      <Index.Box className="admin-dashboard-content admin-user-management-content">
        <Index.Box className="admin-user-list-flex admin-page-title-main">
          <Index.Typography
            className="admin-page-title admin-user-list-page-title"
            component="h2"
            variant="h2"
          >
            Season List
          </Index.Typography>
          <Index.Box className="admin-userlist-btn-flex">
            <Index.Box className="admin-search-main">
              <Index.Box className="admin-search-box">
                <Index.Box className="admin-form-group">
                  <Index.TextField
                    fullWidth
                    id="fullWidth"
                    className="admin-form-control"
                    placeholder="Search"
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                  <img
                    src={PagesIndex.Svg.search}
                    className="admin-search-grey-img admin-icon"
                    alt="search"
                  ></img>
                </Index.Box>
              </Index.Box>
            </Index.Box>

            {adminDetails?.roleId?.permissions?.includes("season_add") && (
              <Index.Box className="admin-userlist-inner-btn-flex">
                <Index.Box className="admin-adduser-btn-main btn-main-primary">
                  <Index.Button
                    className="admin-adduser-btn btn-primary"
                    onClick={() => handleOpenAddSeasons("Add")}
                  >
                    <img
                      src={PagesIndex.Svg.plus}
                      className="admin-plus-icon"
                      alt="plus"
                    />
                    <span>Add Season</span>
                  </Index.Button>
                </Index.Box>
              </Index.Box>
            )}
          </Index.Box>
        </Index.Box>

        <Index.Box className="common-card">
          <Index.Box className="admin-seasons-table-main page-table-main">
            <Index.TableContainer
              component={Index.Paper}
              className="table-container"
            >
              <Index.Table aria-label="simple table" className="table">
                <Index.TableHead className="table-head">
                  <Index.TableRow className="table-row">
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="4%"
                    >
                      Sr. No.
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="7%"
                    >
                      Season Name
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="7%"
                    >
                      Series Name
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Cast
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="3%"
                    >
                      Status
                    </Index.TableCell>
                    {adminDetails?.roleId?.permissions?.includes(
                      "episode_view"
                    ) && (
                        <Index.TableCell
                          component="th"
                          variant="th"
                          className="table-th"
                          width="5%"
                        >
                          Add Episode
                        </Index.TableCell>
                      )}
                    {(adminDetails?.roleId?.permissions?.includes("season_delete") ||
                      adminDetails?.roleId?.permissions?.includes("season_edit")) && (
                        < Index.TableCell
                          component="th"
                          variant="th"
                          className="table-th"
                          align="right"
                          width="5%"
                        >
                          Action
                        </Index.TableCell>)}
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody className="table-body">
                  {loading ? (
                    <PagesIndex.Loader />
                  ) : (
                    <TableData
                      filteredData={filteredData}
                      currentPage={currentPage}
                      handleOpenAddSeasons={handleOpenAddSeasons}
                      handleOpenDelete={handleOpenDelete}
                      handleChangeStatusSeason={handleOpenStatusModal}
                    />
                  )}
                </Index.TableBody>
              </Index.Table>
            </Index.TableContainer>
          </Index.Box>
          <Index.Box className="admin-pagination-main">
            {filteredData?.length ? (
              <Index.Pagination
                page={currentPage}
                count={Math.ceil(filteredData?.length / 10)}
                onChange={(event, newPage) => setCurrentPage(newPage)}
                variant="outlined"
                shape="rounded"
                className="admin-pagination"
              />
            ) : (
              ""
            )}
          </Index.Box>
        </Index.Box>
      </Index.Box >

      <Index.Modal
        open={openAddSeasons}
        onClose={handleCloseAddSeasons}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <Index.Box
          sx={style}
          className="admin-add-user-modal-inner-main admin-modal-inner"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleAddEditSeason}
            initialValues={initialValues}
            validationSchema={PagesIndex.seasonSchema}
            innerRef={formRef}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit} noValidate="novalidate">
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {addOrEdit} Season
                  </Index.Typography>
                  {/* <Index.Button
                    className="modal-close-btn"
                    onClick={handleCloseAddSeasons}
                  >
                    <img
                      src={PagesIndex.Svg.closeblack}
                      className="admin-modal-close-icon"
                      alt="Close"
                    />
                  </Index.Button> */}
                </Index.Box>
                <Index.Box
                  className="admin-modal-hgt-scroll cus-scrollbar"
                  id="scrollDiv"
                >
                  {/* <ScrollIntoView /> */}
                  <Index.Box className="admin-input-box admin-modal-input-box">
                    <Index.FormHelperText className="admin-form-lable">
                      Series Name
                    </Index.FormHelperText>
                    <Index.Box className="admin-form-group">
                      <Index.TextField
                        fullWidth
                        id="fullWidth"
                        className="admin-form-control"
                        placeholder="Enter Series Name"
                        value={title}
                        disabled
                      />
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="admin-input-box admin-modal-input-box">
                    <Index.FormHelperText className="admin-form-lable">
                      Season Name<span className="astrick-sing">*</span> (Max
                      Character Length:50)
                    </Index.FormHelperText>
                    <Index.Box className="admin-form-group">
                      <Index.TextField
                        fullWidth
                        id="season"
                        className="admin-form-control"
                        placeholder="Enter Season Name"
                        onChange={handleChange}
                        name="season"
                        value={values?.season}
                        error={errors.season && touched.season}
                      />
                      {touched.season && errors.season && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.season}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="admin-input-box admin-add-movie-input-box input-complete-box">
                    <Index.FormHelperText className="admin-form-lable">
                      Cast<span className="astrick-sing">*</span>
                    </Index.FormHelperText>
                    <Index.Box className="admin-form-group">
                      <Index.FormControl className="admin-form-control admin-auto-complete-control">
                        <Index.Autocomplete
                          className="admin-auto-complete-filed"
                          options={castData}
                          id="cast"
                          multiple
                          disableCloseOnSelect
                          closeText={""}
                          openText={""}
                          clearText={""}
                          value={
                            values?.cast
                              ? castData.filter((data) =>
                                values?.cast?.some(
                                  (cat) => cat?.castId === data?._id
                                )
                              )
                              : []
                          }
                          onChange={(e, selectedOptions) => {
                            setFieldValue(
                              "cast",
                              selectedOptions.map((option) => ({
                                castId: option._id,
                              }))
                            );
                          }}
                          getOptionLabel={(option) => option?.name}
                          renderOption={(props, item) => (
                            <li {...props} key={item?._id}>
                              {item?.name}
                            </li>
                          )}
                          renderInput={(params) => (
                            <Index.TextField
                              fullWidth
                              className="admin-form-control"
                              name="cast"
                              placeholder={
                                values?.cast?.length ? "" : "Select  Cast"
                              }
                              {...params}
                              size="small"
                              variant="outlined"
                            />
                          )}
                        />

                        {touched.cast && errors.cast && (
                          <PagesIndex.FormHelperText className="admin-error-text">
                            {errors.cast}
                          </PagesIndex.FormHelperText>
                        )}
                      </Index.FormControl>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="modal-footer">
                  <Index.Box className="admin-modal-user-btn-flex">
                    <Index.Box className="admin-save-btn-main btn-main-primary">
                      <Index.Button
                        className={`${id ? "update-btn" : "save-btn"} admin-save-user-btn btn-primary`}
                        type="submit"
                        disabled={buttonSpinner}
                      >
                        {buttonSpinner ? <PagesIndex.Spinner /> :
                          (<>
                            <img
                              src={PagesIndex.Svg.save}
                              className="admin-user-save-icon"
                              alt="Save"
                            />
                            <span>{id ? "Update" : "Add"}</span>
                          </>)
                        }
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </form>
            )}
          </PagesIndex.Formik>
        </Index.Box>
      </Index.Modal>

      <Index.Modal
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <Index.Box
          sx={style}
          className="admin-delete-modal-inner-main admin-modal-inner"
        >
          <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
            <Index.Box className="admin-modal-circle-main">
              <img
                src={PagesIndex.Svg.closecircle}
                className="admin-user-circle-img"
                alt="Close"
              />
            </Index.Box>
            <Index.Typography
              className="admin-delete-modal-title"
              component="h2"
              variant="h2"
            >
              Are you sure?
            </Index.Typography>
            <Index.Typography
              className="admin-delete-modal-para admin-common-para"
              component="p"
              variant="p"
            >
              Do you really want to delete this season? This process cannot be
              undone.
            </Index.Typography>
            <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
              <Index.Button
                className="admin-modal-cancel-btn border-btn"
                onClick={handleCloseDelete}
                disabled={deleteButtonSpinner}
              >
                Cancel
              </Index.Button>
              <Index.Button
                className="delete-user admin-modal-delete-btn btn"
                onClick={handleDeleteWebSeason}
                disabled={deleteButtonSpinner}
              >
                {deleteButtonSpinner ? <PagesIndex.Spinner /> : <span>Delete</span>
                }
              </Index.Button>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Modal>
      <PagesIndex.ChangeStatusModal
        data={"season"}
        statusButtonSpinner={statusButtonSpinner}
        openStatusModal={openStatusModal}
        handleCloseStatusModal={handleCloseStatusModal}
        handleChangeStatus={handleStatus}
      />
    </>
  );
}
TableData.propTypes = {
  filteredData: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  handleOpenAddSeasons: PropTypes.func.isRequired,
  handleOpenDelete: PropTypes.func.isRequired,
  handleChangeStatusSeason: PropTypes.func.isRequired,
};
